import { render, staticRenderFns } from "./FilePage.vue?vue&type=template&id=c5818a36&scoped=true"
import script from "./FilePage.vue?vue&type=script&lang=js"
export * from "./FilePage.vue?vue&type=script&lang=js"
import style0 from "./FilePage.vue?vue&type=style&index=0&id=c5818a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5818a36",
  null
  
)

export default component.exports